// extracted by mini-css-extract-plugin
module.exports = {"content":"ForeseeContent__content___OTsdt","heading":"ForeseeContent__heading___1Y5OK"};